import { Building2 } from "lucide-react";

import { Avatar } from "@/shared/ui/Avatar";
import type { ComboboxOption } from "@/shared/ui/Combobox";

/** The client picker's value for "no client": an internal project. */
export const NO_CLIENT = "internal";

/** Matches the server's limit on project and task descriptions. */
export const DESCRIPTION_MAX_LENGTH = 20_000;

interface Person {
  id: string;
  name: string;
  avatar_url?: string | null;
}

/** A person in a picker: their avatar and name, with a role or "You" under it. */
export function personOption(person: Person, description?: string): ComboboxOption {
  return {
    value: person.id,
    label: person.name,
    description,
    leading: <Avatar name={person.name} src={person.avatar_url} className="size-5 text-[10.5px]" />,
  };
}

export function clientOption(client: { id: string; name: string }): ComboboxOption {
  return {
    value: client.id,
    label: client.name,
    leading: <Building2 className="size-4 shrink-0 text-ink-faint" aria-hidden="true" />,
  };
}
